import { NgModule } from '@angular/core';
import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AppLayoutModule } from './layout/app.layout.module';
import { NotfoundComponent } from './core/notfound/notfound.component';
import { ConfirmationService, MessageService } from 'primeng/api';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { ChangePasswordComponent } from './modules/auth/change-password/change-password.component';
import { LoaderInterceptor } from './core/interceptors/loader.interceptor';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgramIdInterceptor } from './interceptors/program-id.interceptor';

@NgModule({
  declarations: [NotfoundComponent, AppComponent],
  imports: [AppRoutingModule, AppLayoutModule, CommonModule, ProgressBarModule],
  providers: [
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    MessageService,
    ConfirmationService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ProgramIdInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
